import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CreateReminderDialogService {
  public dueDateValue: Date;
  public dueDateValueChange = new Subject<any>();
  public remindersDate: [];

  constructor() {
    this.dueDateValueChange.subscribe(value => {
      this.dueDateValue = value;
    });
  }

  // Existing functionality
  public setFeedbackDueDate(fddDate: Date): void {
    this.dueDateValueChange.next(fddDate);
  }

  public getFeedbackDueDate(): Date {
    return this.dueDateValue;
  }

  public setRemindersDate(reminders: any): void {
    this.remindersDate = reminders;
  }

  public getRemindersDate(): [] {
    return this.remindersDate;
  }

  public calculateDateDiff(): number {
    const currentDate = new Date();
    const dueDate = new Date(this.dueDateValue);
    return Math.floor(
      (Date.UTC(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate()) -
        Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())) /
      (1000 * 60 * 60 * 24)
    );
  }

  // ✅ FormControl sharing for reminderDate and dateShortcut
  private reminderDateControl: FormControl = new FormControl('');
  private dateShortcutControl: FormControl = new FormControl('');

  public setDate(ctrl: FormControl): void {
    this.reminderDateControl = ctrl;
  }

  public getDate(): FormControl {
    return this.reminderDateControl;
  }

  public setDateShortcut(ctrl: FormControl): void {
    this.dateShortcutControl = ctrl;
  }

  public getDateShortcut(): FormControl {
    return this.dateShortcutControl;
  }

  // Optional: keep this if you're still using BehaviorSubject elsewhere
  private reminderDateSubject = new BehaviorSubject<Date | null>(null);
  public reminderDate$ = this.reminderDateSubject.asObservable();

  public setReminderDate(date: Date): void {
    this.reminderDateSubject.next(date);
  }
}
